import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/spotr.webp';
import screenshot_target from '../../../images/letterfunnel/dirkhuibers.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Dirk Huibers"
      firstname="Dirk"
      companyname="Spotr"
      competition="Cape Analytics en Betterview"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/dirkhuibers.js